import { Injectable } from '@angular/core'
import { Project } from '../model/project'
import { Collection, Paginator } from '../model/collection'
import { Field, Filter } from '../model/selector'
import { ConfigService } from '.';
import { Array } from 'core-js';

@Injectable()
export class SelectorService {

	private _selectors: Field[] = [];

	private mainProject: Project = new Project();

	info = 'Enter web site address on the top to load a webpage you want to extract data from.';

	constructor(private configService: ConfigService) {
	}

	createNewProject() {
		if (this.mainProject) {
			this.mainProject = null;
		}
		this.mainProject = new Project();
	}

	addSelector(sel: Field) {
		this._selectors.push(sel);
		return this._selectors.length - 1;
	}

	addNewCollection(collection_name: string, url: string) {
		let coll: Collection = new Collection(collection_name,
			{ 'url': url, 'userToken': this.configService.userToken, 'type': '', actions: [], proxy: '' },
			[]);
		this.mainProject.collections.push(coll);
		return coll;
	}

	addCollection(collection: Collection) {
		this.mainProject.collections.push(collection);
	}

	deleteCollection(collectionName: string) {
		let collection_index = -1;
		for (let index = 0; index < this.mainProject.collections.length; index++) {
			if (collectionName === this.mainProject.collections[index].name) {
				collection_index = index;
				break;
			}
			index++;
		}
		if (collection_index >= -1) {
			this.mainProject.collections.splice(collection_index, 1);
		}
	}

	getProject() {
		return this.mainProject;
	}

	getCollections() {
		return this.mainProject.collections;
	}

	getCollectionByName(name: string) {
		for (let collection of this.mainProject.collections) {
			if (collection.name === name) {
				return collection;
			}
		}
		return null;
	}

	getCollectionByUrl(url: string) {
		for (let collection of this.mainProject.collections) {
			if (collection.request.url === url) {
				return collection;
			}
		}
		return null;
	}

	initCollection(collection: Collection, url: string, proxy: string) {
		collection.request.url = url;
		if (proxy.length > 0) {
			collection.request.proxy = proxy;
		}
		let name = collection.updateName();
		let name_pattern = new RegExp(name, 'g');
		let count = 0;
		for (let coll of this.mainProject.collections) {
			if (coll.name.search(name_pattern) !== -1) {
				count++;
			}
		}
		if (count > 0) {
			name += count;
		}
		collection.name = name;
		collection.format = 'csv';
	}

	updateSelector(id: number, sel: Field) {
		this._selectors[id] = sel;
	}

	deleteSelector(id: number) {
		this._selectors.splice(id, 1);
	}

	getSelectors(): Field[] {
		return this._selectors;
	}

	getFrameWindowRef() {
		return <any>(<HTMLFrameElement>document.getElementById('frame_container')).contentWindow;
	}

	enableSelectorGadget() {
		this.getFrameWindowRef().SelectorGadgetWrapper.enableSelectorGadget();
	}

	disableSelectorGadget() {
		this.getFrameWindowRef().SelectorGadgetWrapper.disableSelectorGadget();
	}

	getElemAttr(css: string, attr: string): string {
		return this.getFrameWindowRef().SelectorGadgetWrapper.getElementAttr(css, attr);
	}

	resetAll() {
		this.getFrameWindowRef().SelectorGadgetWrapper.resetAll();
	}

	initSelectorGadget() {
		this.getFrameWindowRef().SelectorGadgetWrapper.init();
	}

	collectionStringify(export_format: string, collection_name: string) {
		this.mainProject.format = export_format;
		return JSON.stringify(this.mainProject);
	}

	getSelectedCount() {
		return this.getFrameWindowRef().SelectorGadgetWrapper.getCurrentSelectedCount();
	}

	setSelectorPath(selector: Field | Paginator) {
		let regex = '';
		let filters = [];
		let path = selector.selector;
		if (selector instanceof Field) {
			let regexIndex = selector.filterIndex('regex');
			if (regexIndex !== -1) {
				regex = selector.filters[regexIndex].param;
			}
			filters = selector.filters;
		}
		try {
			this.getFrameWindowRef().SelectorGadgetWrapper.setPathEx(path, filters, regex);
		} catch (e) {
			console.log('Failed to set path: ' + e.message);
		}
		return this.getFrameWindowRef().SelectorGadgetWrapper.getCurrentSelectedCount();
	}

	resetSelection() {
		this.getFrameWindowRef().SelectorGadgetWrapper.resetAll();
	}

	suspendGadget() {
		this.getFrameWindowRef().SelectorGadgetWrapper.suspendSelectorGadget();
	}

	resumeGadget() {
		this.getFrameWindowRef().SelectorGadgetWrapper.resumeSelectorGadget();
	}

	getCount(selector: string) {
		return this.getFrameWindowRef().SelectorGadgetWrapper.getCount(selector);
	}

	absolute(base, relative): string {
		let stack = base.split('/'),
			parts = relative.split('/');
		stack.pop(); // remove current file name (or empty string)
		// (omit if "base" is the current folder without trailing slash)
		for (let i = 0; i < parts.length; i++) {
			if (parts[i] === '.') {
				continue;
			}
			if (parts[i] === '..') {
				stack.pop();
			} else {
				stack.push(parts[i]);
			}
		}
		return stack.join('/');
	}
}
